<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="!changed"
    title="ویرایش دستگاه"
    width="600px"
    class="dialog-pt-0"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane label="اطلاعات کلی" name="info">
        <el-row :gutter="10">
          <el-col :span="12" :xs="24" class="mb-3">
            <label class="font-9">کاربر</label>
            <user-select-simple
              v-model="form.userId"
              data-vv-as="کاربر"
              placeholder="کاربر"
              :clearable="true"
            />
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <label class="font-9">عنوان</label>
            <el-input
              v-model="form.title"
              v-validate="'required|max:30'"
              data-vv-as="عنوان"
              placeholder="عنوان"
            />
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <label class="font-9">نام راننده</label>
            <el-input
              v-model="form.driverName"
              data-vv-as="نام راننده"
              placeholder="نام راننده"
            />
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <label class="font-9">شماره راننده</label>
            <el-input
              v-model="form.driverMobile"
              v-validate="'numeric|mobile-no-zero'"
              data-vv-as="شماره راننده"
              placeholder="شماره راننده"
            />
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <label class="font-9">محتویات بار</label>
            <el-input
              v-model="form.containerContent"
              data-vv-as="محتویات بار"
              placeholder="محتویات بار"
            />
          </el-col>
          <el-col :span="12" :xs="24" class="mb-3">
            <label class="font-9">شماره کانتینر</label>
            <el-input
              v-model="form.containerNumber"
              data-vv-as="شماره کانتینر"
              placeholder="شماره کانتینر"
            />
          </el-col>
          <el-col :span="24" :xs="24">
            <label class="font-9">توضیحات</label>
            <el-input
              v-model="form.description"
              type="textarea"
              data-vv-as="توضیحات"
              placeholder="توضیحات"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="سنسورها" name="sensors-setting">
        <el-row :gutter="10">
          <el-col :span="24" :xs="24" class="mb-4">
            <label class="font-9"> دمای مجاز: </label>
            <span class="font-9 number_indicator">
              {{ form.temperature[0] | fixNegativeNumber }} تا
              {{ form.temperature[1] | fixNegativeNumber }}
            </span>
            <el-switch
              v-model="form.deviceTemperature"
              style="float: left"
              active-color="#49d62d"
              inactive-color="#b1b3c7"
            >
            </el-switch>
            <vue-slider
              v-model="form.temperature"
              class="form-boxed-slider"
              :min="-100"
              :max="100"
              :marks="sliderMarks.temperature"
              :contained="true"
              :enable-cross="false"
              :tooltip-formatter="sliderFormatters.temperature"
              :disabled="!form.deviceTemperature"
            ></vue-slider>
            <div style="clear: both"></div>
          </el-col>
          <el-col :span="24" :xs="24" class="mb-4">
            <label class="font-9"> رطوبت مجاز: </label>
            <span class="font-9 number_indicator">
              {{ form.humidity[0] }}% تا %{{ form.humidity[1] }}
            </span>
            <el-switch
              v-model="form.deviceHumidity"
              style="float: left"
              active-color="#49d62d"
              inactive-color="#b1b3c7"
            >
            </el-switch>
            <vue-slider
              v-model="form.humidity"
              class="form-boxed-slider"
              :min="0"
              :max="100"
              :marks="sliderMarks.humidity"
              :contained="true"
              :enable-cross="false"
              :tooltip-formatter="sliderFormatters.humidity"
              :disabled="!form.deviceHumidity"
            ></vue-slider>
            <div style="clear: both"></div>
          </el-col>
          <el-col :span="24" :xs="24" class="mb-4">
            <label class="font-9"> ولتاژ مجاز: </label>
            <el-switch
              v-model="form.deviceBattery"
              style="float: left"
              active-color="#49d62d"
              inactive-color="#b1b3c7"
            >
            </el-switch>
            <el-input-number
              v-model="form.batteryAlarmPercent"
              size="small"
              class="mt-2"
              :max="100"
              :min="0"
              :disabled="!form.deviceBattery"
              style="width: 100%;display: block"
            >
            </el-input-number>
            <div style="clear: both"></div>
          </el-col>
          <el-col :span="24" :xs="24" class="mb-4">
            <label class="font-9"> درصد نور: </label>
            <el-switch
              v-model="form.lightSensor"
              style="float: left"
              active-color="#49d62d"
              inactive-color="#b1b3c7"
            >
            </el-switch>
            <el-input-number
              v-model="form.lightPercent"
              v-validate="'numeric'"
              size="small"
              class="mt-2"
              style="width: 100%;display: block"
              :min="0"
              :max="100"
              data-vv-as="درصد نور"
              placeholder="درصد نور"
              :disabled="!form.lightSensor"
            >
            </el-input-number>
            <div style="clear: both"></div>
          </el-col>
          <el-col :span="24" :xs="24" class="mb-4">
            <label class="font-9"> زمان نمونه گیری: </label>
            <el-input-number
              v-model="form.samplingTime"
              v-validate="'decimal|greater:0.25'"
              size="small"
              class="mt-2"
              style="width: 100%;display: block"
              :min="0"
              :max="24"
              data-vv-as="زمان نمونه گیری"
              placeholder="زمان نمونه گیری"
            >
            </el-input-number>
            <div style="clear: both"></div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-4">
            <label class="font-9"> وقفه جی پی اس (ثانیه): </label>
            <el-input-number
              v-model="form.gpsTimeout"
              v-validate="'numeric'"
              size="small"
              class="mt-2"
              style="width: 100%;display: block"
              :min="0"
              data-vv-as="وقفه جی پی اس (ثانیه):"
              placeholder="وقفه جی پی اس (ثانیه):"
            >
            </el-input-number>
            <div style="clear: both"></div>
          </el-col>
          <el-col :span="12" :xs="24" class="mb-4">
            <label class="font-9"> زمان وقفه دستگاه (ثانیه): </label>
            <el-input-number
              v-model="form.deviceTimeout"
              v-validate="'numeric'"
              size="small"
              class="mt-2"
              style="width: 100%;display: block"
              :min="0"
              data-vv-as="زمان وقفه دستگاه (ثانیه):"
              placeholder="زمان وقفه دستگاه (ثانیه):"
            >
            </el-input-number>
            <div style="clear: both"></div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="هشدار" name="alarm-setting" class="fix-lang">
        <el-row :gutter="10">
          <el-col :span="24" :xs="24" class="mb-4">
            <label class="font-9"> شماره های موبایل:</label>
            <users-number-input
              ref="user-numbers"
              v-model="form.mobilesForNotices"
            />
            <p class="help-text">
              <i class="el-icon-info"></i>
              <span>ابتدا شماره را وارد کرده و سپس دکمه Enter را بزنید</span>
            </p>
          </el-col>
          <el-col :span="24" :xs="24" class="mb-4">
            <p class="alarm-desc">
              آلارم ها برای همه شماره موبایل ها ارسال خواهد شد
            </p>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-form class="mt-4" @submit.native.prevent="submit">
      <div class="text-center mt-4">
        <el-button type="primary" native-type="submit" :loading="addLoading">
          ویرایش
        </el-button>
        <el-button
          :disabled="addLoading"
          @click="cancelSubmit"
          v-text="'انصراف'"
        />
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueTagsInput from '@johmun/vue-tags-input'
import updateDeviceMutation from '@/graphql/device/Update.gql'
import UsersNumberInput from '@/components/UsersNumberInput'
import ItemQuery from '@/graphql/device/Device.gql'
import UserSelectSimple from '@/components/UserSelectSimple'

export default {
  name: 'DeviceForm',
  components: {
    VueSlider,
    VueTagsInput,
    UsersNumberInput,
    UserSelectSimple
  },
  filters: {
    fixNegativeNumber: function(val) {
      if (val < 0) return Math.abs(val) + '-'
      else return val
    }
  },
  props: {
    editingId: { type: [String, Number], default: '' },
    editingItem: { type: Object, default: null },
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      addLoading: false,
      activeTab: 'info',
      sliderFormatters: {
        temperature: value => '℃' + Math.abs(value) + (value < 0 ? '-' : ''),
        humidity: '{value}%'
      },
      setting: null,
      form: {
        imei: '',
        title: '',
        description: '',
        containerNumber: '',
        containerContent: '',
        driverName: '',
        driverMobile: '',
        mobilesForNotices: [],
        deviceTemperature: true,
        temperature: [-10, 35],
        deviceHumidity: true,
        humidity: [0, 50],
        deviceBattery: true,
        batteryAlarmPercent: 0,
        samplingTime: 0,
        lightSensor: null,
        lightPercent: 0,
        deviceTimeout: 0,
        gpsTimeout: 0,
        userId: ''
      }
    }
  },
  computed: {
    editing() {
      if (this.editingId) return this.editingId
      if (this.editingItem) return this.editingItem.id
      return false
    },
    sliderMarks() {
      let globalLabelStyles = {
        direction: 'ltr',
        background: 'rgb(241, 241, 241)',
        width: '50px',
        'text-align': 'center',
        color: 'rgb(160, 160, 160)',
        'border-radius': '5px'
      }

      return {
        temperature: {
          '-100': {
            label: '-100℃',
            labelStyle: {
              ...globalLabelStyles,
              'margin-left': '25px'
            }
          },
          '0': {
            label: '0℃',
            labelStyle: {
              ...globalLabelStyles
            }
          },
          '100': {
            label: '100℃',
            labelStyle: {
              ...globalLabelStyles,
              'margin-left': '-25px'
            }
          }
        },
        humidity: {
          '0': {
            label: '0%',
            labelStyle: {
              ...globalLabelStyles,
              'margin-left': '25px'
            }
          },
          '100': {
            label: '100%',
            labelStyle: {
              ...globalLabelStyles,
              'margin-left': '-25px'
            }
          }
        }
      }
    },
    visible: {
      get() {
        return this.show
      },
      set(val) {
        if (!val) {
          this.$emit('update:editingId', null)
          this.$emit('update:editingItem', null)
          this.activeTab = 'info'
        }
        return this.$emit('update:show', !!val)
      }
    },
    changed() {
      let changed = false
      if (this.editing) {
        if (!this.device) return false
        Object.keys(this.form).forEach(k => {
          if (this.form[k] !== this.device[k]) changed = true
        })
      } else {
        Object.keys(this.form).forEach(k => {
          if (this.form[k] !== '') changed = true
        })
      }
      return changed
    }
  },
  watch: {
    // editingItem: {
    //   immediate: false,
    //   handler(val) {
    //     if (val) {
    //       if (this.editingItem) {
    //         this.setting = { ...this.editingItem }
    //         this.activeTab = 'info'
    //       }
    //     }
    //   }
    // },
    editing: {
      immediate: false,
      handler(val) {
        if (val) {
          this.getItem()
          this.visible = true
        }
      }
    },
    setting: {
      immediate: false,
      handler(val) {
        if (val) {
          this.setEdit(val)
        }
      }
    }
  },
  methods: {
    cancelSubmit() {
      this.visible = false
      this.setEdit()
    },
    setEdit(device) {
      this.form.imei = device.imei || ''
      this.form.title = device.title || ''
      this.form.description = device.description || ''
      this.form.containerNumber = device.containerNumber || ''
      this.form.containerContent = device.containerContent || ''
      this.form.driverName = device.driverName || ''
      this.form.driverMobile = device.driverMobile || ''
      this.form.mobilesForNotices = device.setting.mobilesForNotices || []
      this.form.deviceTemperature = device.setting.alarm.deviceTemperature
      this.form.temperature = [
        device.setting.alarm.minTemperature || -10,
        device.setting.alarm.maxTemperature || 35
      ]
      this.form.deviceHumidity = device.setting.alarm.deviceHumidity
      this.form.humidity = [
        device.setting.alarm.minHumidity || 0,
        device.setting.alarm.maxHumidity || 50
      ]
      this.form.deviceBattery = device.setting.alarm.deviceBattery
      let battery = device.setting.alarm.batteryAlarmLevel
      this.form.batteryAlarmPercent = this.voltagePercent(battery)
      this.form.batteryAlarmPercent = Math.floor(this.form.batteryAlarmPercent)
      this.form.samplingTime = (device.setting.alarm.samplingTime / 60).toFixed(
        2
      )
      this.form.lightSensor = device.setting.alarm.lightSensor
      this.form.lightPercent = device.setting.alarm.lightPercent
      this.form.deviceTimeout = device.setting.alarm.deviceTimeout
      this.form.gpsTimeout = device.setting.alarm.gpsTimeout
      this.form.userId = device.user ? device.user.id : ''
    },
    getItem() {
      if (this.editingItem) {
        this.setting = { ...this.editingItem }
        this.activeTab = 'info'
        return
      }
      this.setting = null
      this.apollo
        .query({
          query: ItemQuery,
          variables: { id: this.editing }
        })
        .then(response => (this.setting = response.data.device))
    },
    submit() {
      if (this.$refs['user-numbers'].$refs['tags-input'].$data['newTag']) return
      let device = { ...this.form }
      device.driverMobile = device.driverMobile.noZero()
      this.$validate().then(() => {
        device.setting = {
          mobilesForNotices: device.mobilesForNotices.map(item =>
            item.noZero()
          ),
          alarm: {
            deviceTemperature: device.deviceTemperature,
            maxTemperature: device.temperature[1],
            minTemperature: device.temperature[0],
            deviceHumidity: device.deviceHumidity,
            maxHumidity: device.humidity[1],
            minHumidity: device.humidity[0],
            deviceBattery: device.deviceBattery,
            batteryAlarmLevel: this.batteryVoltage(device.batteryAlarmPercent),
            samplingTime: Math.round(device.samplingTime * 60),
            lightSensor: device.lightSensor,
            lightPercent: device.lightPercent,
            title: device.title,
            gpsTimeout: device.gpsTimeout,
            deviceTimeout: device.deviceTimeout
          }
        }
        device.id = this.editing
        delete device.batteryAlarmPercent
        delete device.deviceBattery
        delete device.deviceHumidity
        delete device.humidity
        delete device.mobilesForNotices
        delete device.lightPercent
        delete device.lightSensor
        delete device.samplingTime
        delete device.temperature
        delete device.deviceTimeout
        delete device.gpsTimeout

        // delete device.batteryAlarmLevel
        this.loading = true
        this.apollo
          .mutate({
            query: updateDeviceMutation,
            variables: device
          })
          .then(() => {
            this.$message.success('دستگاه با موفقیت آپدیت شد')
            this.$emit('updateTable')
            this.loading = false
            this.visible = false
          })
      })
    },
    voltagePercent(voltage) {
      let range =
        this.$enums.batteryRange['max'] - this.$enums.batteryRange['min']
      if (voltage > this.$enums.batteryRange['max'])
        voltage = this.$enums.batteryRange['max']
      if (voltage < this.$enums.batteryRange['min'])
        voltage = this.$enums.batteryRange['min']
      let diff = voltage - this.$enums.batteryRange['min']
      return Math.floor((diff / range) * 100)
    },
    batteryVoltage(percent) {
      let range =
        this.$enums.batteryRange['max'] - this.$enums.batteryRange['min']
      let voltage = (
        (percent * range) / 100 +
        this.$enums.batteryRange['min']
      ).toFixed(3)
      if (voltage > this.$enums.batteryRange['max'])
        voltage = this.$enums.batteryRange['max']
      if (voltage < this.$enums.batteryRange['min'])
        voltage = this.$enums.batteryRange['min']
      return voltage
    }
  }
}
</script>
